const getTestIdFromText = (message: string | Intl.Message, postfix = '') => {
  const inputText = typeof message === 'string' ? message : message.en

  const camelCaseText = inputText.replace(/(?:^\w|[A-Z]|\b\w|\s+\w)/g, (match, index) =>
    index === 0 ? match.toLowerCase() : match.replace(/\s/, '').toUpperCase()
  )

  const formattedPostfix = postfix ? postfix.charAt(0).toUpperCase() + postfix.slice(1) : ''

  return camelCaseText + formattedPostfix
}

export default getTestIdFromText
